import { render, staticRenderFns } from "./BookItem.vue?vue&type=template&id=4db58309&scoped=true&"
import script from "./BookItem.vue?vue&type=script&lang=js&"
export * from "./BookItem.vue?vue&type=script&lang=js&"
import style0 from "./BookItem.vue?vue&type=style&index=0&id=4db58309&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db58309",
  null
  
)

export default component.exports